exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.user {\n  margin-top: 0.6ex;\n}\n\nlabel:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\nspan.owner {\n  font-style: italic;\n  font-weight: bold;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/edit-project-users-box/edit-project-users-box.component.css
// module id = ../../../../../src/app/edit-project-users-box/edit-project-users-box.component.css
// module chunks = main